import BASEAPI from '../api/gesttor'
import { participarSugestaoPayload } from '../../interfaces/sugestao'


export function toogleSugestao (payload: participarSugestaoPayload) {
    return BASEAPI.post('/suporte/sugestao', payload)
}

